document.addEventListener('DOMContentLoaded', function() {
  if (!window.location.pathname.includes('/tracking')) {
    return;
  }

  function updateStatusChips() {
    const statusChips = document.querySelectorAll('.wndr--shipment-status-chip');

    statusChips.forEach(function(statusChip) {
      const text = statusChip.textContent.trim();
      
      if (statusChip.classList.contains('pre_transit') && text === 'Pre Transit') {
        statusChip.textContent = 'Order Packed';
      }

      if (statusChip.classList.contains('transit') && text === 'Transit') {
        statusChip.textContent = 'In Transit';
      }

      if (statusChip.classList.contains('transit') && text === 'Returned') {
        statusChip.style.backgroundColor = '#EF7373';
        statusChip.textContent = 'Returning to Sender';
      }

      if (statusChip.classList.contains('returned') && text === 'Returned') {
        statusChip.textContent = 'Returned to Sender';
      }

      if (statusChip.classList.contains('pending') && text === 'Order placed. Awaiting fulfillment') {
        statusChip.textContent = 'Order Placed';
      }
    });
  }

  function updateTransitProgressSteps() {
    const stepLabels = document.querySelectorAll('.tp-step-label');

    stepLabels.forEach(function(label) {
      const text = label.textContent.trim();

      if (text === 'Pre Transit') {
        label.textContent = 'Order Packed';
      }

      if (text === 'Transit') {
        label.textContent = 'In Transit';
      }
    });
  }

  function updateReturnedProgressSteps() {
    const steps = document.querySelectorAll('.tp-step-completed');

    steps.forEach(function(step) {
      const label = step.querySelector('.tp-step-label');

      if (!label) {
        return;
      }

      const text = label.textContent.trim();

      if (step.classList.contains('transit') && text === 'Returned') {
        label.textContent = 'Returning to Sender';
      }

      if (step.classList.contains('returned') && text === 'Returned') {
        label.textContent = 'Returned to Sender';
      }
    });
  }

  function updateStatusDescriptions() {
    const messages = document.querySelectorAll('.wndr--shipment-status-message');

    messages.forEach(function(message) {
      const text = message.textContent.trim();

      if (text === 'We are working on your order, please check back later.') {
        message.textContent = 'We received your order and are getting it ready to ship! Check back soon for tracking updates';
      }
    });
  }

  function updateStatusHeaderBlock() {
    const blocks = document.querySelectorAll('[id^="wonderment-tracking-root--shipment-block"]');

    blocks.forEach(function(block) {
      const header = block.querySelector('.tp-shipment-header.wndr--shipment-status-header');

      if (!header) {
        return;
      }

      const preTransitChip =
        header.querySelector('.pre_transit.wndr--shipment-status-chip') ||
        block.querySelector('.tp-last-event .pre_transit.wndr--shipment-status-chip');

      const messageBlock = block.querySelector('.wndr--message-block:not([data-tb-injected])');

      if (messageBlock) {
        messageBlock.style.display = messageBlock.classList.length > 1 ? 'none' : 'block';
      }

      const injected = header.querySelector('.wndr--message-block[data-tb-injected]');

      if (!preTransitChip) {
        // remove if a chip exists and it's a different status
        if (injected && (
          header.querySelector('.wndr--shipment-status-chip') ||
          block.querySelector('.tp-last-event .wndr--shipment-status-chip')
        )) {
          injected.remove();
        }
        return;
      }

      if (injected) {
        return;
      }

      const newMessageBlock = document.createElement('div');
      newMessageBlock.className = 'wndr--message-block';
      newMessageBlock.dataset.tbInjected = '1';

      const span = document.createElement('span');
      span.className = 'wndr--shipment-status-message';
      span.textContent = 'Your order is ready to ship! Check back soon for tracking updates';

      newMessageBlock.appendChild(span);
      header.appendChild(newMessageBlock);
    });
  }

  function updateLastEventDate() {
    const dateDisplays = document.querySelectorAll(
      '.wndr--shipment-events-list .tp-tracker-block .tp-last-event .tp-date-display'
    );

    dateDisplays.forEach(function(dateDisplay) {
      if (dateDisplay.dataset.tbFormatted) {
        return;
      }

      const raw = dateDisplay.textContent.replace(/\s+/g, ' ').trim();
      const separatorIndex = raw.indexOf(' - ');
      const datePart = separatorIndex === -1 ? raw : raw.slice(0, separatorIndex);
      const status = separatorIndex === -1 ? '' : raw.slice(separatorIndex + 3).trim();

      const parts = datePart.replace(/[,-]/g, ' ').split(/\s+/).filter(Boolean);

      if (parts.length < 4) {
        return;
      }

      const fields = [
        ['tb-date-weekday', parts[0]],
        ['tb-date-month', parts[1]],
        ['tb-date-day', parts[2]],
        ['tb-date-year', parts[3]],
        ['tb-date-status', status]
      ];

      const container = document.createElement('div');
      container.className = 'tb-date-container';

      fields.forEach(function(field) {
        if (!field[1]) {
          return;
        }

        const part = document.createElement('div');
        part.className = field[0];
        part.textContent = field[1];
        container.appendChild(part);
      });

      dateDisplay.dataset.tbFormatted = '1';
      dateDisplay.textContent = '';
      dateDisplay.appendChild(container);
    });
  }

  function moveStatusChipToDateBlock() {
    const blocks = document.querySelectorAll('[id^="wonderment-tracking-root--shipment-block"]');

    blocks.forEach(function(block) {
      const header = block.querySelector('.tp-shipment-header.wndr--shipment-status-header');
      const chip = header && header.querySelector('.wndr--shipment-status-chip');

      if (!chip) {
        return; // already moved, or no chip rendered
      }

      const container = block.querySelector('.tp-last-event .tb-date-container');

      if (!container) {
        return; // no events yet - leave the chip in the header
      }

      const slot = container.querySelector('.tb-date-status');

      if (slot) {
        slot.replaceWith(chip);
      } else {
        container.appendChild(chip);
      }
    });
  }

  function updateStatusLabels() {
    updateStatusChips();
    updateTransitProgressSteps();
    updateReturnedProgressSteps();
    updateStatusDescriptions();
    updateStatusHeaderBlock();
    updateLastEventDate();
    moveStatusChipToDateBlock();
  }

  updateStatusLabels();

  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes && mutation.addedNodes.length) {
        updateStatusLabels();
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});